import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { connect } from 'react-redux';
import { useFormik } from 'formik';
import * as Yup from "yup";
import { login } from '../../actions/authAction';
import { partnerCreate, checkInvitationEmail, acceptInvitation } from '../../actions/partnerActions'
import logo from '../../assets/icons/MetaBrief_horizontal_RBG.jpg'
import { toast } from 'react-toastify';
import PhoneInput from 'react-phone-number-input';
import { VALIDATE_PASSWORD, VALIDATE_CONTACT_NO, VALIDATE_NAME} from '../../constants/constants'

const FormPartner = (props) => {
    const history = useHistory();
    const dispatch = useDispatch();
    const [viewPassword, setViewPassword] = useState('password')
    const [projectID, setProjectID] = useState()
    const [userEmailCode, setUserEmailCode] = useState()
    const [invitationType, setInvitationType] = useState()
    const [invitedUser, setInvitedUser] = useState()

    const { loading } = useSelector(state => state.register)
    const { isRegisterd, isRegisterdUser, projectTitle} = useSelector(state => state.partnerStore)
    const formik = useFormik({
        initialValues: {
            first_name: '',
            last_name: '',
            agency_name: '',
            contact_no: '',
            password: '',
            avatar: '',
            passwordConfirmation: '',
        },
        validationSchema: Yup.object({
            first_name: Yup.string().required('First Name is requied').min(3, 'First name should be greater than 3').max(15, 'First name should be less than 15').matches(VALIDATE_NAME, "Only alphabates are allowed for this field").test('first_name', 'First name is required', (value) => value?.trim()),
            last_name: Yup.string().required('Last Name is requied').min(3, 'Last name should be greater than 3').max(15, 'Last name should be less than 15').matches(VALIDATE_NAME, "Only alphabates are allowed for this field").test('last_name', 'Last name is required', (value) => value?.trim()),
            contact_no: Yup.string().required('Mobile Number is requied').matches(VALIDATE_CONTACT_NO, "Enter valid mobile number"),
            // agency_name: Yup.string().required('Agency name is requied').matches(VALIDATE_NAME, "Only alphabates are allowed for this field").test('agency_name', 'Agency name is required', (value) => value.trim()),
            password: Yup.string().max(12, 'Must be 12 characters or less').min(6, 'Must be 6 characters or more').required('Please Enter your password').matches(VALIDATE_PASSWORD, "Must contain 6 characters, one uppercase, one lowercase, one number and one special case character"),
            passwordConfirmation: Yup.string().oneOf([Yup.ref('password'), null], 'Passwords must match'),
            avatar: Yup.string(),
        }),
        onSubmit: (value, { resetForm }) => {
            console.log(value);

            const formData = new FormData();
            formData.append('invited_user_email', userEmailCode);
            formData.append('project_id', projectID);
            formData.append('invitation_type', invitationType);
            formData.append('first_name', value.first_name);
            formData.append('last_name', value.last_name);
            formData.append('agency_name', value.agency_name);
            formData.append('password', value.password);
            formData.append('agency_logo', value.avatar);
            formData.append('contact_no', value.contact_no);
            // dispatch(updateProfile(formData, history))
            //    for (var value of formData.values()) {
            //     console.log(value);
            //  }
            dispatch(partnerCreate(formData, history));
            resetForm();
        },
    });
    useEffect(() => {
        // if (!localStorage.getItem('forgotPassword')) {
        //     history.push('/')
        // }
       // console.log(isRegisterd, 'user status')
        const queryParams = new URLSearchParams(props.location.search)
        const emailCode = queryParams.get("invited_user")
        const id = queryParams.get("project")
        const type = queryParams.get("type")
        const invited_to = queryParams.get("invited_to")
        if (emailCode && id && type) {
            dispatch(checkInvitationEmail(emailCode, id));
            setProjectID(id);
            setInvitationType(type);
            setUserEmailCode(emailCode);
            setInvitedUser(invited_to);
        } else {
            toast.error('Invailid Url')
            history.push('/');
        }
        //dispatch(getUser(match.params.id))
        if (isRegisterdUser) {
            toast.error('Your verification link has been already used.')
            history.push('/');
        }
    }, [isRegisterd, dispatch, history, isRegisterdUser, props])

    const handleClick = (e) => {
        e.preventDefault();
        const passwordStatus = viewPassword === 'password' ? 'text' : 'password'
        setViewPassword(passwordStatus);
    }
    const handleClickAcceptInvitation = (acceptStatus) => {
        const formData = {
            invited_user_email: userEmailCode,
            invitation_type: invitationType,
            isAccept: acceptStatus,
            project_id: projectID,
        }
        dispatch(acceptInvitation(formData, history));

    }
    return (
        <div id="wrapper" className="a uth-main">
            <div className="container">
                <div className="row clearfix">
                    {/* <div className="col-12">
                        <nav className="navbar navbar-expand-lg">
                            <span className="navbar-brand" ><img src={logo} width="130" height="40" className="d-inline-block align-top mr-2" alt="" /></span>
                            <ul className="navbar-nav">
                                <li className="nav-item"><Link className="nav-link" to="/login">LogIn</Link></li>
                            </ul>
                        </nav>
                    </div> */}

                    {isRegisterd ?
                        <>
                            <div className='col-md-4 mx-auto'>
                                <div className="card custom_card border-radius-10">
                                    <div className="header text-center pb-0">
                                        <p className="lead"><span className="navbar-brand" ><img src={logo} width="110" height="auto" className="img-fluid mt-2" alt="" /></span></p>

                                        <h4 className="lead"><strong>Accept Invitation</strong></h4>
                                    </div>
                                    <div className="body">
                                        <div className="body modal-body">
                                            <div className="form-auth-small">
                                                <div className="form-group">
                                                    <label>Join as a {invitedUser} on "{projectTitle}" project </label>
                                                </div>
                                                <div className='row'>
                                                    <div className='col-sm-12 col-md-6 col-lg-6'>
                                                        <button className="btn custom-btn-outline-info btn-sm btn-block" onClick={() => handleClickAcceptInvitation(true)} disabled={loading ? true : false}>Accept</button>
                                                    </div>
                                                    <div className='col-sm-12 col-md-6 col-lg-6'>
                                                        <button className="btn btn-outline-danger btn-sm btn-block" onClick={() => handleClickAcceptInvitation(false)}>Decline</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </> :
                        <>
                            <div className='col-md-4 mx-auto'>
                                <div className="card custom_card border-radius-10">
                                    <div className="header text-center pb-0">
                                        <p className="lead"><span className="navbar-brand" ><img src={logo} width="110" height="auto" className="img-fluid mt-2" alt="" /></span></p>

                                        <h4 className="lead"><strong>Accept Invitation</strong></h4>
                                    </div>
                                    <div className="body">
                                        <form className="form-auth-small" encType="multipart/form-data" onSubmit={formik.handleSubmit}>
                                            <div className="form-group">
                                                <label htmlFor="signup-first_name" className="control-label sr-only">First Name<span className="text-danger">*</span></label>
                                                <input type="text" {...formik.getFieldProps('first_name')} className="form-control custom_form_new_input custom_form_new_input" id="signup-first_name" placeholder="First Name" />
                                                {formik.touched.first_name && formik.errors.first_name ? (
                                                    <div className="text-danger pt-1">{formik.errors.first_name}</div>
                                                ) : null}
                                            </div>
                                            <div className="form-group">
                                                <label className="control-label sr-only" htmlFor="name">Last Name<span className="text-danger">*</span></label>
                                                <input type="text" {...formik.getFieldProps('last_name')} className="form-control custom_form_new_input" placeholder="Last Name" required />
                                                {formik.touched.last_name && formik.errors.last_name ? (
                                                    <div className="text-danger pt-1">{formik.errors.last_name}</div>
                                                ) : null}
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="signup-agency_name" className="control-label sr-only">Company Name</label>
                                                <input type="agency_name" {...formik.getFieldProps('agency_name')} className="form-control custom_form_new_input" placeholder="Company Name" required />
                                                {formik.touched.agency_name && formik.errors.agency_name ? (
                                                    <div className="text-danger pt-1">{formik.errors.agency_name}</div>
                                                ) : null}
                                            </div>
                                            <div className="form-group">
                                                <input
                                                    type="file"
                                                    name="avatar"
                                                    className="form-control custom_form_new_input"
                                                    id="customFile"
                                                    accept="images/*"
                                                    onChange={(event) => {
                                                        const files = event.target.files[0];
                                                        formik.setFieldValue("avatar", files);
                                                    }}
                                                // {...formik.getFieldProps('avatar')}
                                                />
                                                {formik.touched.avatar && formik.errors.avatar && <p className='text-danger mt-2'>{formik.errors.avatar}</p>}
                                            </div>
                                            <div className="form-group">
                                                <PhoneInput
                                                    className="form-control custom_form_new_input"
                                                    defaultCountry="AU"
                                                    countries={["AU"]}
                                                    placeholder="Enter contact number"
                                                    name="contact_no"
                                                    {...formik.getFieldProps('contact_no')}
                                                    onChange={(value) => { formik.setFieldValue('contact_no', value) }}
                                                />

                                                {formik.touched.contact_no && formik.errors.contact_no ? (
                                                    <div className="text-danger pt-1">{formik.errors.contact_no}</div>
                                                ) : null}
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="signup-password" className="control-label sr-only">Password<span className="text-danger">*</span></label>
                                                <div className='pass-wrapper'>
                                                    <input name="password" type={viewPassword} {...formik.getFieldProps('password')} className="form-control custom_form_new_input" placeholder="Password" required />
                                                    <span className="password__show" onClick={handleClick}>{viewPassword === 'text' ? <i className='fa fa-eye eyeIcon'></i> : <i className='eyeIcon fa fa-eye-slash'></i>}</span>
                                                </div>
                                                {formik.touched.password && formik.errors.password ? (
                                                    <div className="text-danger pt-1">{formik.errors.password}</div>
                                                ) : null}
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="signup-password" className="control-label sr-only">Confirm Password<span className="text-danger">*</span></label>
                                                <input type="password" {...formik.getFieldProps('passwordConfirmation')} className="form-control custom_form_new_input" placeholder="Confirm Password" required />
                                                {formik.touched.passwordConfirmation && formik.errors.passwordConfirmation ? (
                                                    <div className="text-danger pt-1">{formik.errors.passwordConfirmation}</div>
                                                ) : null}
                                            </div>
                                            <button type="submit" className="btn button btn-lg btn-block" disabled={loading ? true : false}>SUBMIT</button>
                                        </form>

                                    </div>
                                </div>
                            </div>

                        </>
                    }
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = (state) => ({
    user: state.user,
    loading: state.loading,
    error: state.error,
});

const mapDispatchToProps = {
    login,
};

export default connect(mapStateToProps, mapDispatchToProps)(FormPartner);
